import React, { useState, useEffect, useRef } from "react";
import Axios from "axios";
import "../App.css";
import { message } from "antd";
import { useNavigate, useLocation } from "react-router-dom";
import appIcon from "../assets/images/appIcon_round.webp";
import back from "../assets/images/back_arrow.png";

export default () => {
  const [phoneNo, setPhoneNo] = useState("");
  const [sendingOTP, setSendingOTP] = useState(false);
  const [buttonHide, setButtonHide] = useState(false);
  const [verifyButtonHide, setVerifyButtonHide] = useState(false);

  const [OTPbackendResponse, setOTPBackendResponse] = useState("");

  const [isEmptyPhoneNo, setIsEmptyPhoneNo] = useState(false);
  const [OTPsectionHide, setOTPSectionHide] = useState(false);
  const [OTPVerificationsectionHide, setOTPVerificationSectionHide] =
    useState(false);
  const [msg, setMsg] = useState("");
  const [successMsg, setSuccessMsg] = useState("");
  const [patientDetails, setPatientDetails] = useState([]);
  const [medicaltrackingbt, setMedicaltrackingbt] = useState([]);
  const [isBtRecord, setIsBtRecord] = useState(false);
  const [medicaltrackingbs, setMedicaltrackingbs] = useState([]);
  const [isBsRecord, setIsBsRecord] = useState(false);
  const [medicaltrackingbp, setMedicaltrackingbp] = useState([]);
  const [medicaltrackinghr, setMedicaltrackinghr] = useState([]);
  const [isBpRecord, setIsBpRecord] = useState(false);
  const [isHrRecord, setIsHrRecord] = useState(false);
  const [OTPvalidated, setOTPValidated] = useState(true);
  const [yourOTP, setYourOTP] = useState("");
  const [isDisplayOTP, setIsDisplayOTP] = useState(false);
  const [isUseridLogin, setIsUseridLogin] = useState(false);

  const [otp, setOtp] = useState(new Array(6).fill(""));
  const [lastThreeDigits, setLastThreeDigits] = useState("");
  const inputRefs = useRef([]);

  const onComplete = (otp) => {
    console.log("OTP entered:", otp);
    // You can add any additional logic here if needed
  };

  const handleChange = (index, value) => {
    if (isNaN(value)) return; // Allow only numbers

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    // Auto-focus next input
    if (value && index < 5) {
      inputRefs.current[index + 1].focus();
    }

    // Trigger onComplete if all fields are filled
    if (newOtp.every((digit) => digit !== "")) {
      onComplete(newOtp.join(""));
    }
  };

  const handleKeyDown = (index, e) => {
    if (e.key === "Backspace") {
      // If the current input is empty, move focus to the previous input and clear its value
      if (!otp[index] && index > 0) {
        const newOtp = [...otp];
        newOtp[index - 1] = ""; // Clear the previous input
        setOtp(newOtp);
        inputRefs.current[index - 1].focus();
      }
    }

    // Allow navigation with arrow keys
    if (e.key === "ArrowLeft" && index > 0) {
      inputRefs.current[index - 1].focus();
    }
    if (e.key === "ArrowRight" && index < 5) {
      inputRefs.current[index + 1].focus();
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pasteData = e.clipboardData.getData("text/plain").trim();
    if (pasteData.length === 6 && !isNaN(pasteData)) {
      const newOtp = pasteData.split("").slice(0, 6);
      setOtp(newOtp);
      onComplete(newOtp.join(""));
    }
  };

  const navigate = useNavigate();
  const location = useLocation();

  const phoneNoChangeHandler = (e) => {
    setPhoneNo(e.target.value);
    setLastThreeDigits(e.target.value.substr(-3));
  };

  useEffect(() => {
    let phoneno = localStorage.getItem("phoneNo");
    let useID = localStorage.getItem("user_id");
    if (phoneno != null) {
      navigate("/");
    } else if (useID != null) {
      navigate("/");
    }
  });

  const sendOTPHandler = () => {
    if (phoneNo != "") {
      setSendingOTP(true);
      setButtonHide(true);
      setIsEmptyPhoneNo(false);
      setMsg("");
      Axios.get(
        `${process.env.REACT_APP_GLOBAL_BASEURL}/api/patientapi/AuthController/authenticate_patient?phone_number=${phoneNo}&MDT=PM`
      )
        .then((response) => {
          if (response.data.data != null) {
            if (response.data.token) {
              localStorage.setItem("token", response.data.token);

              Axios.get(
                `${process.env.REACT_APP_GLOBAL_BASEURL}/api/commonapi/Misc/send_login_otp?phone=${response.data.data.phone_number}&MDT=PM&user_role=rp`
              )
                .then((OTPresponse) => {
                  setYourOTP(OTPresponse.data);
                  setSendingOTP(false);
                  setButtonHide(false);
                  message.success("OTP sent successfully! Please check your phone to proceed.");
                  if (OTPresponse.data.OTP_SMS_RESPONSE == "No") {
                    setOTPBackendResponse(OTPresponse.data.OTP);
                    setOTPSectionHide(true);
                    setIsDisplayOTP(true);
                  } else {
                    setIsDisplayOTP(false);
                    setOTPBackendResponse(OTPresponse.data.OTP);
                    setOTPSectionHide(true);
                    setIsDisplayOTP(false);
                  }
                })
                .catch((err) => {
                  console.log("Reset Password: otp send failed", err);
                  message.error("Failed to send OTP. Please try again later.");
                  setSendingOTP(false);
                  setButtonHide(false);
                });
            }
          } else {
            setSendingOTP(false);
            setButtonHide(false);
            setMsg(
              "This phone number is not registered. Please sign up to use this app."
            );
          }
        })
        .catch((err) => {
          console.log("error", err);
        });
    } else {
      setIsEmptyPhoneNo(true);
      setButtonHide(false);
    }
  };

  const verifyOTPHandler = () => {
    setVerifyButtonHide(true);
    setSendingOTP(true);
    const newOtp = otp.join("");
    if (OTPbackendResponse == newOtp) {
      localStorage.setItem("phoneNo", phoneNo);
      setSuccessMsg("Verified! MyMedical Records is showing");
      setMsg("");
      setVerifyButtonHide(true);
      setSendingOTP(false);
      setOTPVerificationSectionHide(true);
      navigate("/");
    } else {
      setMsg("OTP is not matching");
      setSuccessMsg("");
      setVerifyButtonHide(false);
      setSendingOTP(false);
    }
  };

  const resendOTP = () => {
    Axios.get(
      `${process.env.REACT_APP_GLOBAL_BASEURL}/api/commonapi/Misc/send_login_otp?phone=${phoneNo}&MDT=PM&user_role=rp`
    )
      .then((OTPresponse) => {
        setYourOTP(OTPresponse.data);
        setSendingOTP(false);
        setButtonHide(false);
        message.success("OTP resend successfully! Please check your phone.");
        if (OTPresponse.data.OTP_SMS_RESPONSE == "No") {
          setOTPBackendResponse(OTPresponse.data.OTP);
          setOTPSectionHide(true);
          setIsDisplayOTP(true);
        } else {
          setIsDisplayOTP(false);
          setOTPBackendResponse(OTPresponse.data.OTP);
          setOTPSectionHide(true);
          setIsDisplayOTP(false);
        }
      })
      .catch((err) => {
        console.log("Reset Password: otp send failed", err);
        message.error("Failed to resend OTP. Please try again later.");
        setSendingOTP(false);
        setButtonHide(false);
      });
  };

  return (
    <div className="background-container">
      {OTPsectionHide == false ? (
        <div
          style={{
            width: "80%",
            height: "100%",
            borderRadius: "15px",
            justifyContent: "center",
            alignItems: "center",
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
          }}
        >
          <div>
            <img
              src={appIcon}
              style={{ height: 130, width: 130, marginTop: 5 }}
            />
          </div>
          <div>
            <h3
              style={{
                textAlign: "center",
                marginTop: 50,
                fontWeight: "bold",
                fontSize: 24,
              }}
            >
              Sign In
            </h3>
          </div>

          <div style={{ textAlign: "center" }}>
            <div
              style={{
                textAlign: "left",
                marginBottom: "10px",
                marginTop: "30px",
              }}
            >
              <a
                style={{
                  textDecoration: "none",
                  fontSize: 15,
                  fontWeight: "600",
                }}
              >
                Phone Number
              </a>
            </div>
            <input
              onChange={(event) => phoneNoChangeHandler(event)}
              style={{
                border: "1px solid rgb(185, 184, 184)",
                backgroundColor: "#DDDDDD",
                color: "black",
                width: "100%",
                height: 40,
                fontSize: 16,
                borderRadius: 8,
                textAlign: "center",
              }}
              type="tel"
              placeholder=" Enter phone number"
              maxLength={10}
            />
          </div>

          <div style={{ marginTop: 5, textAlign: "center" }}>
            {isEmptyPhoneNo ? (
              <p style={{ fontSize: 16, fontWeight: "bold", color: "red" }}>
                Please enter phone no
              </p>
            ) : null}
            {msg ? (
              <p
                style={{
                  fontSize: 16,
                  fontWeight: "bold",
                  color: "red",
                  marginTop: 10,
                }}
              >
                {msg}
              </p>
            ) : null}

            {buttonHide == false ? (
              <button className="otp_button" onClick={sendOTPHandler}>
                SEND OTP
              </button>
            ) : null}

            {sendingOTP ? (
              <p
                style={{ fontSize: 16, fontWeight: "bold", color: "#6080eeed" }}
              >
                Sending...
              </p>
            ) : null}
          </div>

          <div style={{ marginTop: 20, textAlign: "center" }}>
            <p>or</p>
            <p>
              Signin using&nbsp;
              <a
                style={{
                  textDecoration: "none",
                  fontSize: 15,
                  fontWeight: "bold",
                }}
                href="/UserIdLogin"
              >
                UserID
              </a>{" "}
            </p>
          </div>
          <div style={{ marginTop: 20, textAlign: "center" }}>
            <p>
              Don't have an account?&nbsp;
              <a
                style={{
                  textDecoration: "none",
                  fontSize: 15,
                  fontWeight: "bold",
                }}
                href="/SignUp"
              >
                SignUp
              </a>{" "}
            </p>
          </div>
        </div>
      ) : null}
      {OTPsectionHide == true && OTPVerificationsectionHide == false ? (
        <div>
          <header className="header">
            <img
              src={back}
              style={{ height: 20, width: 20 }}
              alt="back button"
              onClick={() => {
                setOTPSectionHide(false);
              }}
            />
            <h1 className="header-title">Verify OTP</h1>
          </header>
          <div
            style={{
              width: "330px",
              height: "80%",
              borderRadius: "15px",
              justifyContent: "center",
              alignItems: "center",
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
            }}
          >
            <div>
              <h5
                style={{
                  textAlign: "center",
                  fontWeight: "bold",
                  fontSize: 14,
                  marginTop: 70,
                  padding: "40px",
                  alignSelf: "center",
                  color: "#6080eeed",
                }}
              >
                We have sent a verification code to your mobile number, please
                verify
              </h5>
            </div>
            {isDisplayOTP ? (
              <p
                style={{
                  fontSize: 16,
                  fontWeight: "bold",
                  color: "#6080eeed",
                  marginTop: 50,
                }}
              >
                Your OTP is : {OTPbackendResponse}
              </p>
            ) : (
              <p
                style={{
                  fontSize: 16,
                  fontWeight: "bold",
                  color: "#6080eeed",
                  marginTop: 20,
                }}
              >
                Please enter otp received on your mobile *******{lastThreeDigits}
              </p>
            )}
            <div>
              {otp.map((digit, index) => (
                <input
                  key={index}
                  type="tel"
                  maxLength="1"
                  value={digit}
                  ref={(el) => (inputRefs.current[index] = el)}
                  onChange={(e) => handleChange(index, e.target.value)}
                  onKeyDown={(e) => handleKeyDown(index, e)}
                  onPaste={handlePaste}
                  onFocus={(e) => e.target.select()}
                  style={{
                    width: "40px",
                    height: "50px",
                    margin: "0 5px",
                    textAlign: "center",
                    fontSize: "20px",
                    fontWeight: "bold",
                    borderRadius: "8px",
                    border: "1px solid #ccc",
                  }}
                />
              ))}
            </div>
            <p
              style={{ fontSize: 16, color: "#6080eeed", marginTop: 12 }}
              onClick={resendOTP}
            >
              Resend Otp
            </p>

            {verifyButtonHide == false ? (
              <button className="otp_button" onClick={verifyOTPHandler}>
                VERIFY OTP
              </button>
            ) : null}

            {sendingOTP ? (
              <p style={{ fontSize: 16, fontWeight: "bold", color: "#6080eeed" }}>
                Verifing...
              </p>
            ) : null}
            {
              <p style={{ fontSize: 16, fontWeight: "bold", color: "red" }}>
                {msg}
              </p>
            }
          </div>
        </div>
      ) : null}
    </div>
  );
};